const SESSION_KEY = "icare-connect-session";

function safeGet(storage, key) {
  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
}

function safeSet(storage, key, value) {
  try {
    storage.setItem(key, value);
  } catch (error) {
    // private mode / iframe
  }
}

function safeRemove(storage, key) {
  try {
    storage.removeItem(key);
  } catch (error) {
    // private mode / iframe
  }
}

export function queryString(query) {
  if (!query || typeof query !== "object") {
    return "";
  }
  const params = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    const value = query[key];
    if (value != null && value !== "") {
      params.append(key, value);
    }
  });
  const text = params.toString();
  return text ? `?${text}` : "";
}

export function persistSession(data) {
  if (!data) {
    return;
  }
  safeSet(localStorage, SESSION_KEY, JSON.stringify(data));
}

export function loadSession() {
  const raw = safeGet(localStorage, SESSION_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

export function clearSession() {
  safeRemove(localStorage, SESSION_KEY);
}

export function isLoginPath(pathname) {
  const path = (pathname || "").toLowerCase();
  return (
    path === "/login" ||
    path.startsWith("/login/") ||
    path === "/loginauto" ||
    path.startsWith("/loginauto") ||
    path.startsWith("/app/login")
  );
}

export function tenantFromHostname(hostname) {
  const host = String(hostname || "").split(":")[0];
  const isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(host);
  if (isIp || host === "localhost" || host.endsWith(".localhost")) {
    return "";
  }
  const parts = host.split(".");
  if (parts.length > 2 && parts[0] !== "www") {
    return parts[0];
  }
  return "";
}

export function leavePublicShell() {
  const tenant = tenantFromHostname(window.location.hostname);
  if (tenant) {
    window.location.replace(
      `/login/${encodeURIComponent(tenant)}${window.location.search}${window.location.hash}`
    );
    return;
  }
  window.location.replace("/index.html");
}

export function goToApp(query) {
  window.location.replace(`/app/portal${queryString(query)}`);
}

export function goToLogin(options) {
  const opts = options || {};
  const domain = opts.domain;
  const path = domain && domain !== "www"
    ? `/login/${encodeURIComponent(domain)}`
    : "/login";
  const here = (window.location.pathname || "").toLowerCase();
  if (here === path.toLowerCase()) {
    return;
  }
  window.location.replace(`${path}${queryString(opts.query)}`);
}
